import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import parse from 'html-react-parser';

import { colors } from 'styles/colors';
import { devices } from 'styles/devices';

export const BoxImage = ({ image, headline, description, path }) => {
   const renderContent = () => (
      <Wrapper>
         <ImageWrapper>
            <Image src={image} />
         </ImageWrapper>
         {!!headline && <Headline uppercase={!!description}>{parse(headline || '')}</Headline>}
         {!!description && <Description>{parse(description || '')}</Description>}
      </Wrapper>
   );

   if (path) return <StyledLink to={path}>{renderContent()}</StyledLink>;

   return renderContent();
};

BoxImage.propTypes = {
   image: PropTypes.string.isRequired,
   description: PropTypes.string,
   headline: PropTypes.string,
   path: PropTypes.string
};

BoxImage.defaultProps = {
   description: '',
   headline: '',
   path: ''
};

const StyledLink = styled(Link)`
   display: block;
   color: ${colors.neutral60};

   &:hover {
      transform: scale(0.99);
      color: ${colors.neutral60};
      text-decoration: none;
   }
`;

const Wrapper = styled.div`
   padding: 40px 20px;
   border: 1px solid ${colors.neutral30};
   border-radius: 10px;
   margin: 0 0 20px 0;

   ${devices.mobileL} {
      margin: 0;
   }

   ${devices.desktopHD} {
      padding: 40px;
   }
`;

const ImageWrapper = styled.div`
   margin: 0 0 24px 0;
`;

const Image = styled.img`
   display: block;
   width: 100%;
   height: 200px;
   object-fit: contain;
`;

const Headline = styled.span`
   display: block;
   padding: 0;
   margin: 0;
   color: ${colors.neutral60};
   font-size: 16px;
   line-height: 1.4;

   ${({ uppercase }) =>
      uppercase &&
      css`
         font-weight: 700;
         text-transform: uppercase;
      `}
`;

const Description = styled.span`
   display: block;
   padding: 0;
   margin: 0;
   font-size: 12px;
`;

export const GridImage = styled.div`
   display: block;
   margin-top: 14px;

   ${devices.mobileL} {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-gap: 20px;
   }

   ${devices.desktopHD} {
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 30px;
   }

   ${devices.desktopFHD} {
      grid-gap: 40px;
   }
`;

export default BoxImage;
